import React, { FC } from 'react';

//devextreem
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';

import { useDeleteCashFlowExpenseSalaryDetailMutation } from 'bus/cash';

type Props = {
  detailId: number | null;
  cashFlowId: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DeleteModal: FC<Props> = ({ changeVisible, detailId, cashFlowId, refresh, visible }) => {
  const [deleteCashFlowExpenseSalary, { isLoading }] = useDeleteCashFlowExpenseSalaryDetailMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();
    if (detailId && cashFlowId) await deleteCashFlowExpenseSalary({ cashFlowId, detailId });
    refresh();
    changeVisible(false);
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить?</div>

            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DeleteModal;
